export default [
  {
    title: 'Virtual Card for SBUs',
    customIcon: 'NavArrowSvg',
    children: [
      
      {
        title: 'Admin Approve',
        route: 'custom-virtual-card-for-sbu-admin-approved-list',
        path: '/custom-virtual-card-for-sbu/admin-approved-list',
      },
      {
        title: "Admin Upload file",
        route: "custom-virtual-card-for-sbu-upload-file-list",
        path: "/custom-virtual-card-for-sbu/admin-upload-file-list",
      },
    ]
  },
];